import tw from 'twin.macro';

const SingleColGrid = tw.div`w-full grid grid-cols-1 gap-4 pt-2 px-0 md:px-4 relative`;
export default SingleColGrid;
